<template>
  <div id="app">
    <router-view v-if="isRouterShow"/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    provide () {
      return {
        reload: this.reload
      }
    },
    data () {
      return {
        isRouterShow: true
      }
    },
    methods: {
      async reload () {
        this.isRouterShow = false;
        await this.$nextTick();
        this.isRouterShow = true
      }
    }
  }
</script>

<style>
  @import "./assets/css/main.css";
  @import "./assets/css/color-dark.css";     /*深色主题*/
</style>



// WEBPACK FOOTER //
// src/App.vue